import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const fileCard: ThemeUICSSObject = {
  '&.fileCard': {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderColor: 'palette.border.field',
    borderRadius: 'default',
    boxShadow: `0px 1px 1px #c7c7c7`,
    background: 'palette.background.paper',
    p: 3,

    '.fileCard__container': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      position: 'relative',
      borderRadius: 'default',
      background: 'palette.background.paper',
      cursor: 'pointer',
    },
    '.fileCard__preview': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pt: 3,

      img: {
        borderRadius: 'default',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
        width: 'auto',
        height: 'auto',
        objectFit: 'contain',
      },
    },

    '.fileCard__content': {
      display: 'flex',
      alignItems: 'center',
      gap: 3,
      width: '100%',
    },

    button: {
      boxShadow: 'none',
    },
  },

  '&.selected': (theme) => {
    return {
      backgroundColor: theme.palette.getColor('transparent', 'selected'),
    };
  },
  '&.fileList__modal': {
    // pr: 7,
  },

  '.file__icon': {
    flexShrink: 0,
  },

  '.fileCard__name': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  '.fileCard__additionalButtons': {
    flexShrink: 0,
    display: 'flex',
    height: '100%',
    ml: 3,
  },
  '.fileCard__additionalButtons:hover': {
    color: 'palette.text.primary',
  },
  '.fileCard__delete, .fileCard__additionalButton': {
    width: 'auto',
    height: '100%',
    backgroundColor: 'inherit',
    border: 'none',
    m: 0,
    flexShrink: 0,
    px: 3,
    borderRadius: 'default',
    color: 'palette.text.primary',
    svg: {
      width: '18px',
      height: '18px',
    },
  },

  '.fileCard__additionalButton[class]:hover': (theme) => {
    return {
      backgroundColor: theme.palette.getColor(
        theme.palette.background.paper,
        'hover',
      ),
      color: 'palette.text.primary',
    };
  },
};

export default fileCard;
